import axios from 'axios';

const customLogoPaths = [
  '/custom/logo.png',
  '/custom/logo.jpg',
  '/custom/logo.jpeg',
  '/custom/logo.gif',
  '/custom/logo.svg'
];

export const getLoginImage = async () => {
  const viableLogo = [];

  await Promise.all(
    customLogoPaths.map(async logoPath => {
      const logoResult = await tryGetLogoImage(
        `${process.env.PUBLIC_URL}${logoPath}?v=${new Date().getTime()}`
      );
      if (logoResult.available) {
        viableLogo.push(logoResult.path);
      }
    })
  );

  if (!viableLogo.length) {
    return;
  }

  return viableLogo[0];
};

const tryGetLogoImage = path => {
  return axios(`${path}`, { method: 'HEAD' })
    .then(response => {
      return {
        path,
        available:
          response.status < 400 &&
          response.headers['content-type'].includes('image')
      };
    })
    .catch(() => {
      return { path, available: false };
    });
};
